import React from 'react';
import Button from '../Button';
import './DotInfoBox.css';

function DotInfoBox({
  title = '',
  content = '',
  isexpanded = false,
  isToggled = false,
  onTitleClick = () => {},
  onToggle = () => {},
  onClose = () => {}
}) {
  return (
    <div
      className={
        'infoBox' + (isexpanded ? '' : ' Hidden') + (isToggled ? ' bolded' : '')
      }
      id="infoBox"
    >
      <span className="boxTitle" onClick={onTitleClick}>
        {title}
      </span>
      <span className="boxContent" dangerouslySetInnerHTML={{ __html: content }} />
      {isexpanded && (
        <div className="toggleSelect">
          <span className="infoClose noselect" onClick={onClose}>
            x
          </span>
        </div>
      )}
      {isexpanded && !isToggled && (
        <div className="infoContainer">
          <div className="infoSelect">
            <Button
              variant="blue"
              shape="round"
              onClick={() => onToggle(true)}
            >
              Select
            </Button>
          </div>
        </div>
        )}
      </div>
  );
}

export default DotInfoBox;
